import { useEffect, useRef } from "react";
import "./styles/GiftIntro.css";

export default function GiftIntro({ onOpened }) {
  const wrapRef = useRef(null);

  useEffect(() => {
    const wrap = wrapRef.current;
    let step = 1;
    const stepDurations = [1000, 300];

    const run = () => {
      wrap.className = "merrywrap step-" + step;
      if (step === 2) {
        const timer = setTimeout(() => {
          onOpened?.();
          wrap.style.transition = "opacity .4s ease";
          wrap.style.opacity = "0";
          wrap.style.pointerEvents = "none";
        }, stepDurations[1]);
        return () => clearTimeout(timer);
      }
      setTimeout(() => { step++; run(); }, stepDurations[step - 1]);
    };
    run();
  }, [onOpened]);

  return (
    <>
      <div className="gift-intro-wrapper">
        <div ref={wrapRef} className="merrywrap step-1">
          <div className="giftbox">
            <div className="cover"><div /></div>
            <div className="box" />
          </div>
        </div>
      </div>
    </>
  );
}